var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../../../domain';
/** Uma medicao numa celula: o valor formatado e, quando cabe, a faixa. */
let CellScope = class CellScope extends Scope {
    constructor() {
        super(...arguments);
        this.value = '-';
        /**
         * Para onde a celula leva, SELADO e sem o `#` - vazio quando ela nao leva a lugar
         * nenhum. Hoje so a de sono: abre o Relatorio de Sono da pessoa (19/10/2026).
         */
        this.href = '';
        this.onOpen = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CellScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CellScope.prototype, "statusName", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CellScope.prototype, "statusColor", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CellScope.prototype, "href", void 0);
CellScope = __decorate([
    Observable
], CellScope);
export { CellScope };
/**
 * Uma linha da tabela.
 *
 * As celulas sao scopes e nao strings porque cada uma carrega faixa e cor, e
 * porque o valor bruto precisa sobreviver para a ordenacao acontecer por numero e
 * nao por texto - `sortValue` e o que a torna ordenavel.
 */
let CollaboratorRowScope = class CollaboratorRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.patientId = 0;
        /**
         * O endereco do detalhe, SELADO e sem o `#`.
         *
         * O nome e um link de verdade (a referencia usa `Link`), para que o botao do
         * meio abra em outra aba. Quem monta o endereco e o presenter, e nao a view,
         * por duas razoes: o place do detalhe depende de quem hospeda a lista - a
         * mesma linha e desenhada em Colaboradores e em Monitoramentos -, e o endereco
         * precisa do selo, que so a aplicacao sabe dar.
         */
        this.href = '';
        this.name = '-';
        this.criticalCount = 0;
        this.updatedAt = '-';
        /** As celulas de medicao, na ordem das colunas. */
        this.cells = [];
        this.onOpen = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorRowScope.prototype, "patientId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorRowScope.prototype, "href", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorRowScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CollaboratorRowScope.prototype, "company", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CollaboratorRowScope.prototype, "sourceTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CollaboratorRowScope.prototype, "sourceIcon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorRowScope.prototype, "criticalCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorRowScope.prototype, "updatedAt", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CollaboratorRowScope.prototype, "cells", void 0);
CollaboratorRowScope = __decorate([
    Observable
], CollaboratorRowScope);
export { CollaboratorRowScope };
/** Uma coluna, e o que ela oferece: rotulo e ordenacao. */
let ColumnScope = class ColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = '';
        this.label = '';
        this.sortable = true;
        this.sorted = false;
        this.descending = false;
        /** A coluna pode ser arrastada para outro lugar (B-42) - so as de medicao. */
        this.movable = false;
        this.onSort = Scope.ASYNC_ACTION;
        /** Outra coluna, `source`, foi solta sobre esta. */
        this.onDrop = () => undefined;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "sortable", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "sorted", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "descending", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnScope.prototype, "movable", void 0);
ColumnScope = __decorate([
    Observable
], ColumnScope);
export { ColumnScope };
/**
 * Uma medicao no seletor de colunas (B-42): marcada, ela vira coluna.
 *
 * `locked` e o indicador em foco - quem chegou pela barra do Dashboard le aquele, e
 * desmarca-lo deixaria a lista sem o que ela foi aberta para mostrar.
 */
let ColumnChoiceScope = class ColumnChoiceScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = '';
        this.label = '';
        this.checked = false;
        this.locked = false;
        this.onToggle = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnChoiceScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnChoiceScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnChoiceScope.prototype, "checked", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ColumnChoiceScope.prototype, "locked", void 0);
ColumnChoiceScope = __decorate([
    Observable
], ColumnChoiceScope);
export { ColumnChoiceScope };
/** Uma opcao de um filtro de escolha unica. */
let FilterOptionScope = class FilterOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], FilterOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterOptionScope.prototype, "current", void 0);
FilterOptionScope = __decorate([
    Observable
], FilterOptionScope);
export { FilterOptionScope };
let FilterScope = class FilterScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.summary = '';
        this.active = false;
        this.enabled = true;
        this.options = [];
        /**
         * O que o gatilho mostra quando nada esta escolhido.
         *
         * O painel antigo NAO poe uma opcao "Todos" na lista: o vazio e o
         * `placeholder` do seletor, e quem limpa e um X que aparece ao lado do valor.
         * Reproduzido - uma opcao a mais mudaria a lista aberta.
         */
        this.placeholder = '';
        /** O valor escolhido, como o seletor do radix o quer: vazio quando nao ha. */
        this.value = '';
        /** O X ao lado do valor. So aparece quando ha valor, como la. */
        this.onClear = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "active", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "enabled", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], FilterScope.prototype, "options", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "placeholder", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FilterScope.prototype, "value", void 0);
FilterScope = __decorate([
    Observable
], FilterScope);
export { FilterScope };
let CollaboratorsScope = class CollaboratorsScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        // Os campos de texto. Espelham o que foi digitado; a busca so sai no submit.
        /**
         * Conta as escritas PROGRAMATICAS nos tres campos de texto.
         *
         * Os campos sao nao controlados e ignoram mudanca de `defaultValue` - e sem
         * isto o "Limpar" esvaziava o scope sem esvaziar a tela. Mesmo contador de
         * Meus dados e dos Monitoramentos.
         */
        this.formRevision = 0;
        this.name = '';
        this.cpf = '';
        this.email = '';
        /**
         * O rotulo do seletor de periodo, que segue o modo acima.
         *
         * Mora no scope e nao na view porque quem sabe o modo e o presenter - e porque a
         * palavra e a mesma decisao de produto que deu nome ao combo.
         */
        this.periodLabel = 'Registrou em';
        this.anyFilterActive = false;
        this.onClearContext = Scope.ASYNC_ACTION;
        this.columns = [];
        /** O seletor de colunas (B-42): as medicoes, marcadas as que aparecem. */
        this.columnChoices = [];
        this.rows = [];
        this.page = 1;
        /** Quinze, como o `rowsPerPage={15}` que a referencia passa a tabela. */
        this.perPage = 15;
        this.total = 0;
        this.onNameChanged = Scope.SYNC_ACTION_STRING;
        this.onCpfChanged = Scope.SYNC_ACTION_STRING;
        this.onEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onSubmit = Scope.ASYNC_ACTION;
        this.onClearFilters = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
    }
    get pageCount() {
        return Math.max(1, Math.ceil(this.total / Math.max(1, this.perPage)));
    }
    /**
     * As paginas que o paginador oferece - lista pronta, e nao uma regra a aplicar.
     *
     * Deriva de `page` e `pageCount`, os dois ja observados, entao muda junto com
     * eles. Fica aqui e nao na view para que outra renderizacao so LEIA: quem desenha
     * nao precisa saber que a janela tem cinco nem que ela se centra na atual.
     */
    get pageWindow() {
        return pageWindow(this.page, this.pageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CollaboratorsScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "formRevision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CollaboratorsScope.prototype, "companyFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CollaboratorsScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CollaboratorsScope.prototype, "registrationPeriod", void 0);
__decorate([
    observe(),
    __metadata("design:type", FilterScope)
], CollaboratorsScope.prototype, "measurementTypeFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", FilterScope
    /**
     * CADASTRO - todos, ou so os ativos.
     *
     * Virou controle porque e um criterio que MUDA a contagem e ninguem podia mexer:
     * ele chega ligado de todo cartao de Adocao e Engajamento (la toda contagem de
     * pessoas exige cadastro ativo) e vivia so como uma frase no aviso acima da tabela.
     * Dava para desligar TUDO pelo "Ver todos", e nao para desligar so ele.
     *
     * E o criterio que separa 16 de 17 em "Ja registraram treino": um cadastro
     * desativado que continuou treinando.
     *
     * Nao confundir com o filtro de PERIODO ao lado, que pergunta outra coisa: este e o
     * ESTADO do cadastro (`user.active`), e aquele e o COMPORTAMENTO - quem registrou
     * algo entre duas datas. Os dois sao independentes, e e por isso que o periodo se
     * chama "REGISTROU EM" e nao "ativo em": a palavra "ativo" no painel e do cadastro,
     * e usa-la nos dois faria parecer que um implica o outro.
     */
    )
], CollaboratorsScope.prototype, "statusFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", FilterScope
    /**
     * Se a ficha tem ANAMNESE preenchida.
     *
     * Entrou em 23/09/2026 para o degrau "Preencheram a anamnese" e o cartao "Sem
     * anamnese" terem para onde levar. E pergunta da FICHA, e nao da conta - como a
     * faixa de saude ao lado, e diferente de CADASTRO, que e da conta.
     */
    )
], CollaboratorsScope.prototype, "accountsFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", FilterScope
    /**
     * Como LER o periodo ao lado: presenca (o padrao), ausencia, ou "parou".
     *
     * Entrou em 23/09/2026 para os cartoes "Nunca registraram" e "Parados" terem para
     * onde levar - eram subtracoes na outra tela, e subtracao nao vira filtro sozinha.
     *
     * Muda o SENTIDO do controle vizinho, e por isso o rotulo dele vem daqui
     * (`periodLabel`): "ATIVIDADE: Nao registrou" ao lado de "REGISTROU EM" seria a
     * fileira se contradizendo.
     */
    )
], CollaboratorsScope.prototype, "anamneseFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", FilterScope
    /**
     * O rotulo do seletor de periodo, que segue o modo acima.
     *
     * Mora no scope e nao na view porque quem sabe o modo e o presenter - e porque a
     * palavra e a mesma decisao de produto que deu nome ao combo.
     */
    )
], CollaboratorsScope.prototype, "activityFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "periodLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "anyFilterActive", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CollaboratorsScope.prototype, "contextNotice", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CollaboratorsScope.prototype, "columns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CollaboratorsScope.prototype, "columnChoices", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CollaboratorsScope.prototype, "layout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CollaboratorsScope.prototype, "rows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "page", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "perPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CollaboratorsScope.prototype, "total", void 0);
CollaboratorsScope = __decorate([
    Observable
], CollaboratorsScope);
export { CollaboratorsScope };
//# sourceMappingURL=collaborator-list.scope.js.map